/* eslint-disable no-console */
import IMask from 'imask';
import flatpickr from 'flatpickr';
import onChange from 'on-change';
import AddressesMap from '../../AddressesMap';
import configs from '../../../globals/configs';
import selectors from '../../../globals/selectors';
import disablePageScroll from '../../../helpers/disablePageScroll';
import enablePageScroll from '../../../helpers/enablePageScroll';
import formatDate from './helpers/formatDate';
import htmlToDom from '../../../helpers/htmlToDom';
import makeAddressElement from './render/makeAddressElement';
import makeSelectedDateInfoHtml from './render/makeSelectedDateInfoHtml';
import makeSelectedTimeInfoHtml from './render/makeSelectedTimeInfoHtml';
import makeServiceCard from './render/makeServiceCard';
import makeStep4 from './render/makeStep4';
import makeStep5 from './render/makeStep5';
import makeTimeList from './render/makeTimeList';
import respondToVisibility from '../../../helpers/respondToVisibility';

// TODO вынести рендер функции в модули

export default class Index
{
	#modalEl;
	#nextStepBtn;
	#prevStepBtn;
	#stepperSteps;
	#stepContentEls;
	#toggleEls;
	#closeBtnEl;
	#spinner;
	#serviceCardEls = [];
	#servicesContainer;
	#handleServiceCardCheckboxChange;
	#addressesEls;
	#map;
	#handleMapPlacemarkClick;
	#handleAddressClick;
	#addressesContainer;
	#datePickerEl;
	#dateTodayInfoEl;
	#dateSelectedInfoEl;
	#timesContainer;
	#datePicker;
	#selectedDateTimeInfoContainer;
	#handleNameInput;
	#handlePhoneInput;
	#handleCommentInput;
	#handleAgreeChange;

	init({ modalEl, state }) {
		this.#modalEl = modalEl;
		this.#nextStepBtn = modalEl.querySelectorAll(
			selectors.onlineRegistrationModal.navigation.next
		);
		this.#prevStepBtn = modalEl.querySelectorAll(
			selectors.onlineRegistrationModal.navigation.prev
		);
		this.#stepperSteps = modalEl.querySelectorAll(
			selectors.onlineRegistrationModal.stepper.step
		);
		this.#stepContentEls = modalEl.querySelectorAll(
			selectors.onlineRegistrationModal.stepper.stepContent
		);
		this.#toggleEls = document.querySelectorAll(
			selectors.onlineRegistrationModal.toggle
		);
		this.#closeBtnEl = modalEl.querySelector(
			selectors.onlineRegistrationModal.close
		);
		this.#spinner = modalEl.querySelector(selectors.spinner);
		this.#servicesContainer = this.#modalEl.querySelector(
			selectors.onlineRegistrationModal.services.list
		);
		this.#map = new AddressesMap(
			selectors.onlineRegistrationModal.addresses.map
		);
		this.#addressesContainer = modalEl.querySelector(
			selectors.onlineRegistrationModal.addresses.container
		);
		this.#datePickerEl = modalEl.querySelector(
			selectors.onlineRegistrationModal.datePicker
		);
		this.#datePicker = flatpickr(this.#datePickerEl, configs.datePicker);
		const today = new Date();
		this.#timesContainer = modalEl.querySelector(
			selectors.onlineRegistrationModal.timeContainer
		);
		this.#dateTodayInfoEl = modalEl.querySelector(
			selectors.onlineRegistrationModal.todayInfo
		);
		this.#dateTodayInfoEl.textContent = today.getDate();
		this.#dateSelectedInfoEl = modalEl.querySelector(
			selectors.onlineRegistrationModal.selectedDay
		);
		this.#selectedDateTimeInfoContainer = modalEl.querySelector(
			selectors.onlineRegistrationModal.selectedDatetimeInfo
		);

		return onChange(state, (path, value) =>
		{
			this.renderNavigation({
				step: state.step,
				maxAvailableStep: state.maxAvailableStep,
				isLastStep: state.isLastStep,
			});

			switch (path) {
				case 'isOpened':
					// console.log('CASE >>>', 'isOpened')
					if (value)
						this.open();
					else
						this.close();
					break;
				case 'step':
					this.render(state);
					if (value === 4)
						this.renderStep4(state);

					if (value === 5)
					{
						this.hideNextNavBtn();
						this.renderStep5(state);
					}
					else
						this.showNextNavBtn();
					break;
					case 'ui.allServices':
						// console.log('CASE >>>', 'ui.allServices')
						this.renderServicesList(value);
						break;
				case 'ui.isSpinnerVisible':
					if (value) {
						this.showSpinner();
					} else {
						this.hideSpinner();
					}
					break;
				case 'ui.isNextBtnHidden':
					if (value) {
						this.hideNextNavBtn();
					} else {
						this.showNextNavBtn();
					}
					break;
				case 'ui.isPrevBtnHidden':
					if (value) {
						this.#hidePrevBtn();
					} else {
						this.#showPrevBtn();
					}
					break;
				case 'services':
					// console.log('CASE >>>', 'services')
					if (!this.#serviceCardEls || this.#serviceCardEls.length === 0) break;
					this.renderSelectedServices(value);
					break;
				case 'allAddressesCoords':
					this.renderMapPlacemarks(value);
					this.renderList(value);
					break;
				case 'address':
					this.renderAddressesStep({
						selectedAddress: value.location,
						selectedAddressCoords: value.coords,
					});
					break;
				case 'date':
					this.renderSelectedDayInfo(value);
					this.renderSelectedDate(value);
					break;
				case 'allTimes':
					this.renderTimes(value);
					if (state.date !== null) {
						this.renderSelectedDate(state.date);
					}
					break;
				case 'time':
					this.renderSelectedTime(value);
					break;
				case 'contactDetails.name':
				case 'contactDetails.phone':
				case 'contactDetails.comment':
				case 'contactDetails.processingPersonalDataAgree':
					break;
				case 'response':
					this.renderResponse(value);
					break;
				default:
					throw new Error(`unknown mutation - ${path}: ${value}`);
			}
		});
	}

	initListeners({
		handleToggleElsClick,
		handleCloseBtnClick,
		handleBodyClick,
		handleNextStepBtnClick,
		handlePrevStepBtnClick,
		handleServiceCardCheckboxChange,
		handleMapPlacemarkClick,
		handleAddressClick,
		handleDateChange,
		handleTimeClick,
		handleNameInput,
		handlePhoneInput,
		handleCommentInput
	}) {
		this.#handleServiceCardCheckboxChange = handleServiceCardCheckboxChange;
		this.#handleMapPlacemarkClick = handleMapPlacemarkClick;
		this.#handleAddressClick = handleAddressClick;
		this.#datePicker.config.onChange.push(handleDateChange);
		this.#toggleEls.forEach((el) =>
			el.addEventListener('click', handleToggleElsClick)
		);
		this.#closeBtnEl.addEventListener('click', handleCloseBtnClick);
		this.#nextStepBtn.forEach((el) => {
			el.addEventListener('click', handleNextStepBtnClick);
		});
		this.#prevStepBtn.forEach((el) => {
			el.addEventListener('click', handlePrevStepBtnClick);
		});
		document.body.addEventListener('click', handleBodyClick);
		this.#timesContainer.addEventListener('click', handleTimeClick);
		this.#handleNameInput = handleNameInput;
		this.#handlePhoneInput = handlePhoneInput;
		this.#handleCommentInput = handleCommentInput;
	}

	get #activeStepContainer() {
		return this.#modalEl.querySelector(
			selectors.onlineRegistrationModal.stepper.activeStepContent
		);
	}

	#showPrevBtn() {
		this.#prevStepBtn.forEach((el) => {
			el.classList.remove(
				selectors.onlineRegistrationModal.navBtnHiddenClassName
			);
		});
	}

	#hidePrevBtn() {
		this.#prevStepBtn.forEach((el) => {
			el.classList.add(selectors.onlineRegistrationModal.navBtnHiddenClassName);
		});
	}

	#disableNextBtn() {
		this.#nextStepBtn.forEach((el) => {
			el.setAttribute('disabled', 'disabled');
		});
	}

	#enableNextBtn() {
		this.#nextStepBtn.forEach((el) => {
			el.removeAttribute('disabled');
		});
	}

	showSpinner() {
		this.#activeStepContainer.classList.add(
			selectors.onlineRegistrationModal.dNoneClassName
		);
		this.#spinner.classList.remove(
			selectors.onlineRegistrationModal.dNoneClassName
		);
	}

	hideSpinner() {
		this.#activeStepContainer.classList.remove(
			selectors.onlineRegistrationModal.dNoneClassName
		);
		this.#spinner.classList.add(
			selectors.onlineRegistrationModal.dNoneClassName
		);
	}

	showNextNavBtn() {
		this.#nextStepBtn.forEach((el) => {
			el.classList.remove(selectors.onlineRegistrationModal.dNoneClassName);
		});
	}

	hideNextNavBtn() {
		this.#nextStepBtn.forEach((el) => {
			el.classList.add(selectors.onlineRegistrationModal.dNoneClassName);
		});
	}

	renderNavigation({ step, maxAvailableStep, isLastStep }) {
		if (isLastStep) {
			this.#nextStepBtn.forEach((el) => {
				el.textContent = 'Записаться';
			});
		} else {
			this.#nextStepBtn.forEach((el) => {
				el.textContent = 'Далее';
			});
		}

		if (step === maxAvailableStep) {
			this.#disableNextBtn();
		} else {
			this.#enableNextBtn();
		}
	}

	#renderStepper(step) {
		if (step === 5) {
			this.#stepperSteps.forEach((el) => {
				el.classList.remove(
					selectors.onlineRegistrationModal.stepCurrentClassName
				);
				el.classList.add(selectors.onlineRegistrationModal.stepPassedClassName);
			});
			return;
		}

		this.#stepperSteps.forEach((el) => {
			const stepOfElement = parseInt(el.dataset.rmStepperStep, 10);
			if (stepOfElement === step) {
				el.classList.add(
					selectors.onlineRegistrationModal.stepCurrentClassName
				);
			} else if (stepOfElement < step) {
				el.classList.remove(
					selectors.onlineRegistrationModal.stepCurrentClassName
				);
				el.classList.add(selectors.onlineRegistrationModal.stepPassedClassName);
			} else {
				el.classList.remove(
					selectors.onlineRegistrationModal.stepCurrentClassName
				);
				el.classList.remove(
					selectors.onlineRegistrationModal.stepPassedClassName
				);
			}
		});
	}

	#renderContent(step) {
		this.#stepContentEls.forEach((el) => {
			const stepOfContent = parseInt(el.dataset.rmStep, 10);
			if (stepOfContent === step) {
				el.classList.add(selectors.onlineRegistrationModal.stepActiveClassName);
			} else {
				el.classList.remove(
					selectors.onlineRegistrationModal.stepActiveClassName
				);
			}
		});
	}

	open() {
		this.#modalEl.classList.add(
			selectors.onlineRegistrationModal.showClassName
		);
		disablePageScroll();
	}

	close() {
		this.#modalEl.classList.remove(selectors.onlineRegistrationModal.showClassName);
		enablePageScroll();
	}

	render({ step }) {
		this.#renderStepper(step);
		this.#renderContent(step);
	}

	renderSelectedServices(selectedServices) {
    if (!this.#serviceCardEls?.length) {
        this.#serviceCardEls = document.querySelectorAll(SERVICE_CARD_SELECTOR);
        if (!this.#serviceCardEls.length) return;
    }

    this.#serviceCardEls.forEach(el => {
        const serviceId = el.dataset.rmService;
        const checkbox = el.querySelector('input[type="checkbox"]');
        if (!checkbox) return;

        const isSelected = selectedServices.includes(serviceId);
        checkbox.checked = isSelected;
        el.classList.toggle(
            selectors.onlineRegistrationModal.services.selectedCard,
            isSelected
        );
    });
}

	renderServicesList(services, selectedServices = []) {
    const cards = services.map((service) => makeServiceCard(service));
    this.#servicesContainer.innerHTML = cards.join('');
    
    this.#serviceCardEls = this.#modalEl.querySelectorAll(
        selectors.onlineRegistrationModal.services.card
    );

    this.renderSelectedServices(selectedServices);

    this.#serviceCardEls.forEach((el) => {
        const checkbox = el.querySelector('input[type="checkbox"]');
        checkbox.addEventListener('change', this.#handleServiceCardCheckboxChange);
    });
}

	renderMapPlacemarks(coords) {
		this.#map.initPlacemarks(coords);
		this.#map.onPlacemarkClick(this.#handleMapPlacemarkClick);
		respondToVisibility(this.#map.element).then(() =>
			this.#map.zoomToPlacemarksOnInit()
		);
	}

	#renderAddressesList(selectedAddress) {
		this.#addressesEls.forEach((el) => {
			const address = el.dataset.rmAddress;

			if (selectedAddress === address) {
				el.classList.add(
					selectors.onlineRegistrationModal.addresses.selectedClassName
				);
				el.scrollIntoView({
					block: 'center',
					inline: 'nearest',
				});
			} else {
				el.classList.remove(
					selectors.onlineRegistrationModal.addresses.selectedClassName
				);
			}
		});
	}

	renderMap(selectedCoord = null) {

		const hasSelectedCoord = selectedCoord !== null;
		if (hasSelectedCoord) {
			this.#map.open(selectedCoord);
		} else {
			this.#map.zoomToPlacemarksOnInit();
		}
	}

	renderList(addresses) {
		const addressEls = addresses.map(makeAddressElement);
		addressEls.forEach((el) => {
			el.addEventListener('click', this.#handleAddressClick);
		});
		this.#addressesContainer.replaceChildren(...addressEls);
		this.#addressesEls = addressEls;
	}

	renderAddressesStep({
		selectedAddress = null,
		selectedAddressCoords = null,
	}) {
		this.#renderAddressesList(selectedAddress);

		this.renderMap(selectedAddressCoords);
	}

	renderSelectedDayInfo(date) {
		const container = this.#dateSelectedInfoEl.closest('.date-picker-day');
		if (date === null) {
			container.style.display = 'none';
		} else {
			container.style.display = '';
			this.#dateSelectedInfoEl.textContent = date.getDate();
			this.#datePicker.setDate(date);
		}
	}

	renderTimes(times) {
		const timesEl = makeTimeList(times);
		this.#selectedDateTimeInfoContainer = timesEl.querySelector(
			selectors.onlineRegistrationModal.selectedDatetimeInfo
		);
		this.#timesContainer.replaceChildren(timesEl);
	}

	renderSelectedTime(value) {
		const selectedDateEl = this.#selectedDateTimeInfoContainer.querySelector(
			'[data-rm-selected-date]'
		);
		if (!selectedDateEl) {
			return;
		}
		const selectedDateInfo = selectedDateEl.textContent;
		this.#selectedDateTimeInfoContainer.innerHTML = `
			${makeSelectedDateInfoHtml(selectedDateInfo)}
			${makeSelectedTimeInfoHtml(value)}
		`;
	}

	renderSelectedDate(date) {
		const beatifiedDate = formatDate(date);
		this.#selectedDateTimeInfoContainer.innerHTML =
			makeSelectedDateInfoHtml(beatifiedDate);
	}

	renderStep4({ contactDetails, date, time, services, ui })
	{
		const button = document.querySelectorAll('.modal__btn--next')[3];
		button.setAttribute('disabled', 'disabled');
		const { allServices } = ui;
		const selectedServices = allServices.filter(({ id }) => services.includes(id));
		const servicesText = selectedServices.map(({ name }) => name).join(', ');
		const servicesTime = selectedServices
			.map(({ duration }) => Number(duration))
			.reduce((acc, value) => acc + value, 0);
		const step4El = htmlToDom(makeStep4({contactDetails, date, time, servicesText, servicesTime}));
		const nameInput = step4El.querySelector(selectors.onlineRegistrationModal.nameInput);
		const phoneInput = step4El.querySelector(selectors.onlineRegistrationModal.phoneInput);
		const commentInput = step4El.querySelector(selectors.onlineRegistrationModal.commentInput);
		const phoneMask = new IMask(phoneInput, configs.masks.phone);

		nameInput.addEventListener('input', this.#handleNameInput);
		phoneInput.addEventListener('input', this.#handlePhoneInput);
		commentInput.addEventListener('input', this.#handleCommentInput);
		const step4Container = this.#modalEl.querySelector('[data-rm-step="4"]');
		step4Container.querySelector('p').replaceWith(step4El);
		button.setAttribute('disabled', 'disabled');
	}
	renderStep5({ date, time, services, ui }) {
		const { allServices } = ui;
		const selectedServices = allServices.filter(({ id }) =>
			services.includes(id)
		);
		const servicesText = selectedServices.map(({ name }) => name).join(', ');
		const servicesTime = selectedServices
			.map(({ duration }) => Number(duration))
			.reduce((acc, value) => acc + value, 0);
		const step5El = htmlToDom(
			makeStep5({
				date,
				time,
				servicesText,
				servicesTime,
			})
		);

		const step5Container = this.#modalEl.querySelector('[data-rm-step="5"]');
		step5Container.querySelector('p').replaceWith(step5El);
	}

	renderResponse({ isSuccess, message }) {
		const responseMessageEl = htmlToDom(`
			<div style="
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				height: 50vh;
				padding-top: 40px;
			">
				<h3 style="
					text-align: center; 
					${!isSuccess ? 'color: #b94226;' : ''}
				">${message}</h3>
			</div>
		`);
		if (!isSuccess) {
			this.#modalEl
				.querySelector('[data-rm-step="5"]')
				.replaceChildren(responseMessageEl);
		}
	}
}
